import Settings from '../Settings/Settings.js';
import Footer from '../Footer/Footer.js'

const SettingsWebPage = () => {

    return (
        <div>
            <Settings />
            <Footer />
        </div>
    );
}

export default SettingsWebPage;
